// Opens the Zoho SalesIQ chat window, retrying until the widget bundle (loaded asynchronously) is ready.
const SALESIQ_MAX_ATTEMPTS = 15;
const SALESIQ_RETRY_DELAY = 200;

let retryTimeoutId = null;

function showSalesIQChatWindow(attempt) {
  const salesIQ = window.$zoho?.salesiq;
  if (typeof salesIQ?.floatwindow?.visible !== "function") {
    if (attempt < SALESIQ_MAX_ATTEMPTS) {
      retryTimeoutId = setTimeout(
        () => showSalesIQChatWindow(attempt + 1),
        SALESIQ_RETRY_DELAY,
      );
    }
    return;
  }
  salesIQ.floatwindow.visible("show");
  try {
    salesIQ.chat.start();
  } catch (error) {
    // Deduced from reading the legacy bundle (not verified at runtime):
    // legacy widget builds throw here even though the chat window is
    // already open. Logged instead of swallowed in case this masks a
    // real Zoho API error.
    // eslint-disable-next-line no-console
    console.warn("Zoho SalesIQ chat.start() threw", error);
  }
}

export function openZohoSalesIQChat() {
  showSalesIQChatWindow(0);
}

export function cancelZohoSalesIQChatRetry() {
  if (retryTimeoutId) {
    clearTimeout(retryTimeoutId);
    retryTimeoutId = null;
  }
}
